import { useSelector, useDispatch } from "react-redux";
import { switchLanguageAction } from "@reduxs/Actions/storageAction";
import { stateInterface } from "@reduxs/interface";

const resources = {
  en: {
    signout: {
      signout: "Sign Out",
      title: "Are you sure you want to sign out?",
      cancel: "Cancel",
      confirm: "Sign Out",
    },
    signin: {
      welcome: "Welcome To CORNTROL",
      continue: "Login to Continue",
      email: "Email Address",
      erroremail: "Input Your Email Address",
      password: "Password",
      errorpassword: "Input Your Password",
      signin: "Sign In",
      newuser1: "New user?",
      newuser2: "Create an acount",
      emailrequired: "Email Address is required",
      passwordrequired: "Password is required",
      emailincorrect: "Email is incorrect",
      passwordincorrect: "Password is incorrect",
    },
    register: {
      text1: "registered through the CORNTROL application",
      text2: "Sign in with the same account as the application.",
      text3: "Go to CORNTROL Application",
      text4: "Later",
    },
    noti: {
      howto: "How to enable notifications",
      close: "Close",
      noti: "Notification",
      readall: "Read all",
      areu: "Are you sure to mask as read all of your notifications?",
      cancel: "Cancel",
      confirm: "Confirm",
    },
    profile: {
      profile: "Profile",
      signout: "Sign out",
      signoutconfirm: "Are you sure you want to sign out?",
      cancel: "Cancel",
      info: {
        head: "Infomation",
        updatephoto: "Update photo",
        allowed1: "Allowed *.jpeg, *.jpg, *.png, *.gif",
        allowed2: "Maximum file size 5 MB",
        name: "Name",
        placeholdername: "Input Your Name",
        errorname: "Please Input Your Name",
        email: "Email",
        phone: "Phone Number (Optional)",
        placeholderphone: "Input Your Phone Number",
        bio: "Bio (Optional)",
        placeholderbio: "Input Your Bio",
        save: "Save Change",
        confirmsave: "Confirm changes to personal information",
        successsave: "Successful update of personal information.",
      },
      changepass: {
        head: "Change Password",
        oldpass: "Old Password",
        placeholderoldpass: "Input Your Old Password",
        newpass: "New Password",
        placeholdernewpass: "Input Your New Password",
        confirmpass: "Confirm Password",
        placeholderconfirmpass: "Input Your Confirm Password",
        mincha: "Minimum 8 Characters",
        minupper: "Minimum 1 Uppercase",
        minlower: "Minimum 1 Lowercase",
        minnumber: "Minimum 1 number",
        specialcha: "Special Characters",
        samepass: "The password must be the same",
        confirmchange: "Confirm to change password?",
        when: "When changing your password, you will need to log in to the CORNTROL Application again.",
        errorpass: "The old password is incorrect.",
        successpass: "Password change successful.",
      },
    },
    confirm: {
      confirm: "Confirm",
      cancel: "Cancel",
    },
    support: {
      support: "Support",
      line: "LINE",
      addfriend: "Add friends",
      email: "Email",
      web: "Website",
      connect: "Connect with us",
    },
    monitoring: {
      monitoring: "Monitoring",
      welcome: "Welcome back,",
      title: "Monitor Status and Assess Device Performance",
      total: "Total Devices",
      total1: "Total",
      total2: "Devices",
      normal: "Normal",
      powerOff: "Power off",
      offline: "Offline",
      alarm: "Alarm",
      searchlabel: "Search",
      search: "Search Devices",
      status: "Status",
      all: "All",
      updating: "Updating",
      location: "Location",
      area: "Area",
      show: "Show",
      mode: "Mode",
      automationSchedule: "Schedule",
      eco: "ECO",
      avg: "24H Avg",
      electricity: "Electricity unit",
      unit: "kWh",
      vol: "Voltage",
      volunit: "V",
      currenttemp: "Current Temp",
      lasttemp: "Last Temp",
      mydevice: "My Device",
      sharedevice: "Shared with me",
      detail: "Details",
      lastupdate: "Latest update",
      map: "Map",
      list: "List",
      filter: "Filter",
      reset: "Reset",
      apply: "Apply",
      warning1: "Please specify your device location",
      warning2: "Devices without a set location will not appear on the map.",
      noadddevice: "You haven’t added any devices to this location yet.",
      thislocation: "Current Location",
    },
    sound: "Sound",
    light: "Light",
    dark: "Dark",
    devices: {
      devices: "Devices",
      head: "Device List",
      device: "Device",
      order1: "Alphabet (A-Z)",
      order2: "Alphabet (Z-A)",
      order3: "Newest",
      order4: "Oldest",
      cannotfind: "Can't find your device",
      showdevice: "Show device list",
      page: "page",
    },
    dashboard: {
      dashboard: "Dashboard",
    },
    delete: {
      delete: "Delete account",
      deleteask: "Delete your CORNTROL account?",
      deletetitle:
        "You can stop the deletetion process by logging back in 30 days",
      cancel: "Cancel",
      confirm: "Delete",
    },
    coming: "Coming soon...",
    audioblocked: "Alarm is active — click anywhere to turn the sound on",
    detail: {
      head: "Device Details",
      seemore: "See more",
      deviceinfobtn: "Device info",
      used: "Used",
      electplan: "Electricity unit plan",
      remain: "Remaining",
      information: "Device Information",
      name: "Device Name",
      desc: "Description",
      mac: "Device Mac Address",
      deviceinfo: "Device information",
      image: "Image",
      map: "Map location of Device",
      interval: "Interval Recording",
      min1: "Min",
      min2: "Mins",
      alive: "Keep Alive",
      firmware: "Firmware",
      wifiversion: "Wi-Fi Firmware released version",
      mainversion: "Main Firmware released version",
      newversion: "A new version is available on application.",
      viewmap: "View on map",
      report: "Report",
      history: "History",
      unit: "Unit",
      period: "Period",
      hour: "Hours",
      day: "Days",
      month: "Months",
      perioddate: "Period Date",
      periodtime: "Period Time",
      week: "Weeks",
      temp: "Temperature",
      ope: "Operation",
      power: "Power Meter",
      powerdetail: "Power Meter Data",
      iot: "IOT",
      // Wi-Fi module reset history (tab 5 of the device-detail quick view).
      // wifireset0-6 are the module's reset reason codes, worded as the
      // hardware team supplied them.
      // short enough for the tab button, which is only as wide as the others
      wifievent: "Wi-Fi Module",
      wifieventtitle: "Wi-Fi Module Event Log",
      // Customers seeing a list of restarts tend to assume the cabinet faulted.
      // split so the reassurance can be emphasised — it is the part a worried
      // customer needs to actually land on
      wifieventnote:
        "The events shown are provided for monitoring and analyzing the operation of the Wi-Fi module. Many of these events are part of the module's normal operation or built-in protection mechanisms",
      wifieventnotestrong: "and do not indicate hardware damage or malfunction.",
      wifieventempty: "No events found",
      wifieventfw: "Requires Wi-Fi module firmware version 1.2.0 or later",
      reportfailed: "Couldn't load this report",
      reportfaileddetail:
        "The server took too long to answer. A wide range — a whole month of minute-by-minute records — can exceed the time limit. Try a shorter range, or try again.",
      reportretry: "Try again",
      monthlocked:
        "A month of operation data is more than the server can return in time. Use Week for now — we're changing how this range is prepared.",
      wifieventcode: "Code",
      wifisevinfo: "Information",
      wifisevrecovery: "Self-Recovery",
      wifisevcheck: "Check Installation",
      wifireset0:
        "The Wi-Fi module started operating normally after the initial power-up.",
      // Only the operator knows whether the unit is meant to run continuously,
      // so this points at the interpretation rather than asserting an outage.
      wifireset0detail:
        "Please interpret this event in the context of your equipment's normal operating conditions. For equipment designed to operate continuously, this event may indicate that a power outage or voltage drop has occurred.",
      wifireset1:
        "The Wi-Fi module restarted automatically by the internal protection mechanism (Hardware Watchdog).",
      wifireset1detail:
        "This event occurs when the Hardware Watchdog detects abnormal software operation and automatically resets the module to restore normal operation. If it occurs frequently or repeatedly, contact the service team.",
      wifireset2:
        "The Wi-Fi module restarted after detecting that the module became unresponsive.",
      wifireset2detail:
        "This event may be caused by abnormal software operation or a low supply voltage (voltage drop), resulting in the module becoming unresponsive and restarting. If it occurs frequently or repeatedly, inspect the power supply and contact the service team.",
      wifireset3:
        "The Wi-Fi module restarted automatically by the software protection mechanism (Software Watchdog).",
      wifireset3detail:
        "This event occurs when the Software Watchdog detects abnormal software operation and automatically resets the module to restore normal operation. If it occurs frequently or repeatedly, contact the service team.",
      wifireset4:
        "The Wi-Fi module restarted according to predefined system conditions.",
      wifireset4detail:
        "This event may occur after a firmware update, configuration changes, or a scheduled restart.",
      wifireset5:
        "The Wi-Fi module resumed operation after exiting power-saving mode.",
      wifireset5detail:
        "This event is part of the normal operation of the power-saving mode and does not indicate a hardware malfunction.",
      wifireset6:
        "The Wi-Fi module restarted after detecting an external reset signal.",
      wifireset6detail:
        "This event may be caused by electrical noise or interference affecting the hardware. If it occurs frequently, inspect the power supply, grounding, and installation environment.",
      roomtempsum: "Inside Temperature Summary",
      evaptempsum: "Evaporator Coil Temperature Summary",
      lowest: "Lowest",
      highest: "Highest",
      average: "Average",
      hightempalarm: "High Temp Alarm",
      roomtemp: "Inside Temperature",
      realtemp: "Inside Temperature (Real-time)",
      realtemp2: "Evaporator Coil Temperature (Real-time)",
      settemp: "Set Temp",
      lowtempalarm: "Low Temp Alarm",
      evaptemp: "Evaporator Coil Temperature",
      datatable: "Data Table",
      time: "Time",
      tempunit: "Temperature Unit",
      cel: "Celsius",
      fah: "Fahrenheit",
      temptype: "Temperature Type",
      tempvalue: "Temperature Value",
      min: "Min",
      max: "Max",
      avg: "Average",
      search: "Search Activity",
      activity: "Activity",
      type: "Type",
      by: "By",
      timerSystem: "System Scheduler (Auto Mute)",
      reporttitle: "Temperature Control Report",
      reportsummary: "Temperature summary",
      opesummary: "Operation summary",
      opechart: "Operation chart",
      opetable: "Operation table",
      opecooling: "Cooling cycle",
      opecontrol: "Control",
      statelegend: "Filled bar = on · empty = off · gap = no data",
      reasonpoweroffcooling: "Power off → cooling system stopped",
      reasonpoweroffstate: "Power: off",
      reasoncompon: "Compressor running (cooling down toward the cut-out point)",
      reasoncompoffdefrost: "Compressor off — defrost in progress",
      reasoncompoffcycle: "Compressor off — reached setpoint (restarts once the temperature rises past the differential rd), or in a compressor delay",
      reasondefroston: "Defrost running",
      reasonfanon: "Fan running",
      reasonfanoffdefrost: "Fan off — during defrost",
      reasonfanoffdoor: "Fan off — door is open",
      reasonfanoffconfig: "Fan off — depends on the fan mode (coil temp / follows compressor / post-defrost delay)",
      reasondooropen: "Door is open",
      reasonpoweron: "Power: on (controls everything)",
      reasonlighton: "Light: on",
      reasonlightoff: "Light: off",
      reasondoorclosed: "Door: closed",
      reasonnodata: "No data for this time",
      powersummary: "Power summary",
      powerchart: "Power meter chart",
      powertable: "Power meter table",
      iotsummary: "IoT summary",
      iotchart: "Signal strength chart",
      iottable: "IoT table",
      rssiname: "Signal Strength",
      wifidrop: "Wi-Fi disconnects",
      xlsoperecords: "State records",
      xlsopeevents: "Events",
      changes: "Changes",
      totalreadings: "Total readings",
      duration: "Storage duration",
      dataperiod: "Recording period",
      rowunit: "rows",
      fromrecorded: "of",
      datacount: "Total",
      perpage: "/ page",
      showing: "Showing",
      oftotal: "of",
      xlsinfo: "Summary",
      xlshistory: "History",
      xlsbreaches: "Out-of-range periods",
      xlsfield: "Field",
      xlsvalue: "Data",
      xlsnobreach: "No out-of-range periods in this time range",
      thresholdrange: "Configured threshold",
      outofrange: "Out of range",
      briefexcursion: "Brief excursions",
      loadingdata: "Loading data...",
      reportdownloadbtn: "Full report · PDF/Excel",
      reportexcelbtn: "Full report · Excel",
      xlsstatus: "Status",
      excelwysiwyg:
        "The file matches the table exactly as shown — adjust the data resolution in the filter",
      tipalarm: "Out of range long enough that the device alarmed",
      tipbrief:
        "Back in range within the alert delay, so the device did not alarm",
      nodatarange: "No data found for this period",
      brieftag: "brief",
      alertdelay: "Alert delay",
      secunit: "sec",
      printedat: "Issue date",
      docref: "Document No.",
      issuedby: "Prepared by",
      reporttype: "Report type",
      pagelabel: "Page",
      periodhours: "Hourly",
      perioddays: "Daily",
      periodweeks: "Weekly",
      periodmonths: "Monthly",
      durationcol: "Duration",
      firstreading: "First reading",
      lastreading: "Latest reading",
      hishort: "Hi",
      loshort: "Lo",
      exportpdf: "Download PDF",
      downloadexcel: "Download Excel",
      reportchart: "Temperature chart",
      temptable: "Temperature table",
      breachperiods: "Out-of-range period list",
      readinglist: "Temperature reading table",
      colstart: "Start",
      colend: "End",
      coltype: "Type",
      colpeak: "Peak value",
      collimit: "Limit in force",
      colcount: "Values",
      overhigh: "Above range",
      underlow: "Below range",
      sensorcol: "Sensor 1",
      devicecol: "Device",
      showevery: "showing every",
      minunit: "min",
      page: "Page",
      inspector: "Inspector",
      authorizer: "Authorized signatory",
      recipient: "Service recipient",
      signhere: "Signature",
      signdate: "Date",
      reportsettings: "PDF report settings",
      resolution: "Table resolution",
      dataresolution: "Data resolution",
      recommended: "Recommended",
      resnotrecommend:
        "Finer than recommended for this range — the chart works harder and the data is harder to read. Still allowed.",
      resbreachnote:
        "Out-of-range readings are always listed as their own rows — never folded into the averages — even at a coarser data resolution, so every violation point stays visible.",
      tblsettemp: "Set point",
      tbllowalarm: "Lower limit",
      tblhighalarm: "Upper limit",
      tblinside: "Inside",
      tblinsidert: "Inside (RT)",
      tblcoil: "Coil",
      tblcoilrt: "Coil (RT)",
      includechart: "Include chart in report",
      chartseries: "Chart lines in report",
      confirmdownload: "Confirm — Download PDF",
      recordtype: "Record Type",
      record: "Record",
      event: "Event",
      register: "Sign up",
      starterblocked:
        "Starter-plan devices are not supported on the monitoring system",
      starterblockeddetail:
        "You can keep using this device through the CORNTROL application, or subscribe to the Standard / Professional plan to monitor it here.",
      backtodevices: "Back to device list",
      comp: "Compressor",
      defrost: "Defrost",
      fan: "Fan",
      door: "Door",
      times: "times",
      hrs: "hrs",
      active: "Power",
      light: "Light",
      on1: "On",
      off1: "Off",
      on2: "On",
      off2: "Off",
      actionpower: "Action (Power)",
      actionlight: "Action (Light)",
      appact: "Application activated",
      appdea: "Application deactivated",
      manact: "Manually activated",
      mandea: "Manually deactivated",
      electunit: "Electricity unit",
      electbill: "Electricity bill",
      carbonfootprint: "Carbon footprint",
      carbonunit: "kgCO₂e",
      mode: "Mode",
      unit2: "unit",
      baht: "Baht",
      vol: "Voltage",
      // unit-less variants for the summary tiles, which print the unit under
      // the value — same idea as rssiname
      volname: "Voltage",
      amp: "Amp",
      watt: "Watt",
      wattname: "Power",
      khw: "KWH",
      wifi: "Wi-Fi",
      devicestatus: "Device Status",
      rssi: "Signal Strength (dBm)",
      iothead: "IoT Device — SSID",
      connect: "Connected",
      unable: "Unable to connected",
      online: "Online",
      offline: "Offline",
      iotdetail: "IOT Data",
      opedetail: "Operation Data",
      tempdetail: "Temperature Data",
      etc: "Note: To access this feature on a new device, please activate the Standard Plan.",
      buy: "You have not subscribed to the Standard or Professional plan yet. Please upgrade to access advanced features. For further assistance, please contact our support team via Line Official: @corntrol or email: info@corntrol.com",
    },
    filter:{
      hours: "Date",
      days: "Date",
      weeks: "Week",
      months: "Month",
      years: "Year"
    }
  },
  th: {
    signout: {
      signout: "ออกจากระบบ",
      title: "คุณแน่ใจว่าต้องการออกจากระบบใช่ไหม?",
      cancel: "ยกเลิก",
      confirm: "ออกจากระบบ",
    },
    signin: {
      welcome: "ยินดีต้อนรับสู่ CORNTROL",
      continue: "เข้าสู่ระบบ เพื่อดำเนินการต่อ",
      email: "อีเมล",
      erroremail: "กรุณาระบุอีเมล",
      password: "รหัสผ่าน",
      errorpassword: "กรุณาระบุรหัสผ่าน",
      signin: "เข้าสู่ระบบ",
      newuser1: "ผู้ใช้ใหม่?",
      newuser2: "สร้างบัญชี",
      emailrequired: "กรุณาตรวจสอบ Email ให้ครบถ้วน",
      passwordrequired: "กรุณาตรวจสอบ Password ให้ครบถ้วน",
      emailincorrect: "อีเมลไม่ถูกต้อง",
      passwordincorrect: "รหัสผ่านไม่ถูกต้อง",
    },
    register: {
      text1: "สมัครใช้งานได้ผ่านแอปฯ CORNTROL",
      text2: "เข้าสู่ระบบด้วยบัญชีเดียวกันกับแอปพลิเคชัน",
      text3: "เปิด CORNTROL App",
      text4: "ไว้ก่อน",
    },
    noti: {
      howto: "วิธีการอนุญาตเปิดใช้งานแจ้งเตือน",
      close: "ปิด",
      noti: "การแจ้งเตือน",
      readall: "อ่านทั้งหมด",
      areu: "คุณแน่ใจหรือไม่ว่าต้องการทำเครื่องหมายว่าอ่าน การแจ้งเตือนทั้งหมดแล้ว?",
      cancel: "ยกเลิก",
      confirm: "ยืนยัน",
    },
    profile: {
      profile: "โปรไฟล์",
      signout: "ออกจากระบบ",
      signoutconfirm: "คุณแน่ใจว่าคุณต้องการที่จะออกจากระบบ?",
      cancel: "ยกเลิก",
      info: {
        head: "ข้อมูล",
        updatephoto: "อัปเดตรูป",
        allowed1: "อนุญาต *.jpeg, *.jpg, *.png, *.gif",
        allowed2: "ขนาดไฟล์สูงสุด 5 MB",
        name: "ชื่อ",
        placeholdername: "กรุณากรอกชื่อ",
        errorname: "กรุณากรอกชื่อ",
        email: "อีเมล",
        phone: "เบอร์โทรศัพท์ (ไม่บังคับ)",
        placeholderphone: "กรุณากรอกเบอร์โทรศัพท์",
        bio: "ประวัติโดยย่อ (ไม่บังคับ)",
        placeholderbio: "กรุณากรอกประวัติโดยย่อ",
        save: "บันทึก",
        confirmsave: "ยืนยันการเปลี่ยนแปลงข้อมูลส่วนตัว",
        successsave: "เปลี่ยนแปลงข้อมูลส่วนตัวสำเร็จ",
      },
      changepass: {
        head: "เปลี่ยนรหัสผ่าน",
        oldpass: "รหัสผ่านเดิม",
        placeholderoldpass: "กรุณากรอกรหัสผ่านเดิม",
        newpass: "รหัสผ่านใหม่",
        placeholdernewpass: "กรุณากรอกรหัสผ่านใหม่",
        confirmpass: "ยืนยันรหัสผ่าน",
        placeholderconfirmpass: "กรุณากรอกยืนยันรหัสผ่าน",
        mincha: "อย่างน้อย 8 ตัวอักษร",
        minupper: "อย่างน้อย 1 ตัวพิมพ์ใหญ่",
        minlower: "อย่างน้อย 1 ตัวพิมพ์เล็ก",
        minnumber: "อย่างน้อย 1 ตัวเลข",
        specialcha: "อักขระพิเศษ",
        samepass: "รหัสผ่านต้องตรงกัน",
        confirmchange: "ยืนยันการเปลี่ยนรหัสผ่าน",
        when: "เมื่อมีการเปลี่ยนรหัสผ่าน คุณจำเป็นที่จะต้องเข้าสู่ระบบใน CORNTROL Application อีกครั้ง",
        errorpass: "รหัสผ่านเดิมไม่ถูกต้อง",
        successpass: "เปลี่ยนรหัสผ่านสำเร็จ",
      },
    },
    confirm: {
      confirm: "ยืนยัน",
      cancel: "ยกเลิก",
    },
    support: {
      support: "ช่วยเหลือ",
      line: "ไลน์",
      addfriend: "เพิ่มเพื่อน",
      email: "อีเมล",
      web: "เว็บไซต์",
      connect: "เชื่อมต่อกับเรา",
    },
    monitoring: {
      monitoring: "ตำแหน่งอุปกรณ์บนแผนที่",
      welcome: "ยินดีต้อนรับการกลับมาของคุณ,",
      title: "ติดตามสถานะ และประเมินการทำงานของอุปกรณ์ของคุณ",
      total: "อุปกรณ์ทั้งหมด",
      total1: "อุปกรณ์",
      total2: "ทั้งหมด",
      normal: "ปกติ",
      powerOff: "ปิด",
      offline: "ออฟไลน์",
      alarm: "แจ้งเตือน",
      searchlabel: "ค้นหา",
      search: "ค้นหาอุปกรณ์",
      status: "สถานะ",
      all: "แสดงทั้งหมด",
      updating: "กำลังอัปเดต",
      location: "สถานที่",
      area: "พื้นที่",
      show: "แสดง",
      mode: "โหมด",
      automationSchedule: "กำหนดการ",
      eco: "ประหยัดพลังงาน",
      avg: "เฉลี่ย 24 ชม.",
      electricity: "การใช้ไฟฟ้า",
      unit: "หน่วย",
      vol: "แรงดันไฟฟ้า",
      volunit: "V",
      currenttemp: "อุณหภูมิปัจจุบัน",
      lasttemp: "อุณหภูมิล่าสุด",
      mydevice: "อุปกรณ์ของฉัน",
      sharedevice: "แบ่งปันกับฉัน",
      detail: "ดูรายละเอียด",
      lastupdate: "อัปเดตล่าสุด",
      map: "แผนที่",
      list: "รายการ",
      filter: "ตัวกรอง",
      reset: "ล้างค่า",
      apply: "นำไปใช้",
      warning1: "โปรดระบุตำแหน่งอุปกรณ์ของคุณ",
      warning2: "อุปกรณ์ที่ไม่ได้ระบุตำแหน่ง จะไม่แสดงบนแผนที่",
      noadddevice: "คุณยังไม่ได้เพิ่มอุปกรณ์ในสถานที่นี้",
      thislocation: "ตำแหน่งปัจจุบัน",
    },
    sound: "เสียง",
    light: "โหมดสว่าง",
    dark: "โหมดมืด",
    devices: {
      devices: "อุปกรณ์",
      head: "รายการอุปกรณ์",
      device: "อุปกรณ์",
      order1: "ตัวอักษร (A-Z)",
      order2: "ตัวอักษร (Z-A)",
      order3: "ใหม่ไปเก่า",
      order4: "เก่าไปใหม่",
      cannotfind: "ไม่พบอุปกรณ์ของคุณ",
      showdevice: "แสดงรายการอุปกรณ์",
      page: "หน้า",
    },
    dashboard: {
      dashboard: "ภาพรวม",
    },
    delete: {
      delete: "ลบบัญชี",
      deleteask: "คุณต้องการลบบัญชี CORNTROL ของคุณหรือไม่?",
      deletetitle:
        "คุณสามารถยกเลิกการลบบัญชีได้โดยเข้าสู่ระบบอีกครั้งภายใน 30 วันนับจากวันที่ส่งคำขอลบบัญชี",
      cancel: "ยกเลิก",
      confirm: "ลบ",
    },
    coming: "เร็วๆ นี้...",
    audioblocked: "มีการแจ้งเตือน — คลิกที่หน้าจอเพื่อเปิดเสียง",
    detail: {
      head: "รายละเอียดอุปกรณ์",
      seemore: "ดูเพิ่มเติม",
      deviceinfobtn: "ข้อมูลเครื่อง",
      used: "ใช้แล้ว",
      electplan: "แพลนการใช้ไฟฟ้า",
      remain: "คงเหลือ",
      information: "ข้อมูลเครื่อง",
      name: "ชื่ออุปกรณ์",
      desc: "คำอธิบาย",
      mac: "Mac Address ของอุปกรณ์",
      deviceinfo: "ข้อมูลอุปกรณ์",
      image: "รูป",
      map: "ตำแหน่งของอุปกรณ์บนแผนที่",
      interval: "ระยะเวลาบันทึกข้อมูล",
      min1: "นาที",
      min2: "นาที",
      alive: "Keep Alive",
      firmware: "เฟิร์มแวร์",
      wifiversion: "Wi-Fi Firmware เวอชั่นล่าสุด",
      mainversion: "Main Firmware เวอชั่นล่าสุด",
      newversion: "มีเวอร์ชันใหม่พร้อมอัปเดตที่แอปพลิเคชัน",
      viewmap: "ดูบนแผนที่",
      report: "รายงาน",
      history: "ประวัติ",
      unit: "หน่วย",
      period: "ช่วงเวลา",
      hour: "ชั่วโมง",
      day: "วัน",
      month: "เดือน",
      perioddate: "ช่วงวัน",
      periodtime: "ช่วงเวลา",
      week: "สัปดาห์",
      temp: "อุณหภูมิ",
      ope: "การทำงาน",
      power: "พาวเวอร์มิเตอร์",
      powerdetail: "ข้อมูลพาวเวอร์มิเตอร์",
      iot: "IOT",
      wifievent: "โมดูล Wi-Fi",
      wifieventtitle: "บันทึกเหตุการณ์ของโมดูล Wi-Fi",
      wifieventnote:
        "เหตุการณ์ที่แสดงใช้สำหรับการตรวจสอบและวิเคราะห์การทำงานของโมดูล Wi-Fi หลายเหตุการณ์เป็นส่วนหนึ่งของการทำงานปกติหรือกลไกป้องกันของระบบ",
      wifieventnotestrong: "และไม่ได้บ่งชี้ว่าอุปกรณ์เกิดความเสียหาย",
      wifieventempty: "ไม่พบเหตุการณ์ที่ผ่านมา",
      wifieventfw: "รองรับโมดูล Wi-Fi ที่ใช้เฟิร์มแวร์เวอร์ชัน 1.2.0 ขึ้นไป",
      reportfailed: "ไม่สามารถโหลดรายงานนี้ได้",
      reportfaileddetail:
        "เซิร์ฟเวอร์ใช้เวลาตอบกลับนานเกินกำหนด ช่วงเวลาที่กว้าง เช่น ทั้งเดือนที่เก็บข้อมูลทุกนาที อาจเกินเวลาที่ระบบรอได้ ลองเลือกช่วงที่สั้นลง หรือลองใหม่อีกครั้ง",
      reportretry: "ลองใหม่อีกครั้ง",
      monthlocked:
        "ข้อมูลการทำงานรายเดือนมีปริมาณมากเกินกว่าที่เซิร์ฟเวอร์จะดึงได้ทัน ระหว่างนี้ใช้หน่วยสัปดาห์แทนได้ครับ ระบบกำลังปรับวิธีเตรียมข้อมูลช่วงนี้อยู่",
      wifieventcode: "รหัส",
      wifisevinfo: "ข้อมูล",
      wifisevrecovery: "การกู้คืนอัตโนมัติ",
      wifisevcheck: "แนะนำให้ตรวจสอบ",
      wifireset0: "โมดูล Wi-Fi เริ่มทำงานตามปกติจากการจ่ายไฟครั้งแรก",
      wifireset0detail:
        "โปรดพิจารณาเหตุการณ์นี้ร่วมกับลักษณะการใช้งานของอุปกรณ์ สำหรับอุปกรณ์ที่ควรทำงานต่อเนื่อง เหตุการณ์นี้อาจบ่งชี้ว่าเคยเกิดไฟดับหรือไฟตก",
      wifireset1:
        "โมดูล Wi-Fi เริ่มการทำงานใหม่โดยระบบป้องกันภายใน (Hardware Watchdog)",
      wifireset1detail:
        "เหตุการณ์นี้เกิดขึ้นเมื่อ Hardware Watchdog ตรวจพบว่าซอฟต์แวร์ทำงานผิดปกติ และสั่งรีเซ็ตโมดูลเพื่อให้กลับมาทำงานได้ตามปกติ หากเกิดขึ้นบ่อยครั้งหรือเกิดขึ้นต่อเนื่อง แนะนำให้ปรึกษาทีมบริการ",
      // "Hang" stays in the service manual, not here — customers read it as a
      // broken unit; "หยุดตอบสนอง" says the same thing without the alarm
      wifireset2:
        "โมดูล Wi-Fi เริ่มการทำงานใหม่ หลังตรวจพบว่าการทำงานของโมดูลหยุดตอบสนอง",
      wifireset2detail:
        "เหตุการณ์นี้อาจเกิดจากซอฟต์แวร์ทำงานผิดปกติ หรือแรงดันไฟเลี้ยงต่ำ (ไฟตก) จนทำให้โมดูลหยุดตอบสนองและเริ่มการทำงานใหม่ หากเกิดขึ้นบ่อยครั้งหรือเกิดขึ้นต่อเนื่อง แนะนำให้ตรวจสอบแหล่งจ่ายไฟและปรึกษาทีมบริการ",
      wifireset3:
        "โมดูล Wi-Fi เริ่มการทำงานใหม่โดยระบบป้องกันของซอฟต์แวร์ (Software Watchdog)",
      wifireset3detail:
        "เหตุการณ์นี้เกิดขึ้นเมื่อ Software Watchdog ตรวจพบว่าซอฟต์แวร์ทำงานผิดปกติ และสั่งรีเซ็ตโมดูลเพื่อให้กลับมาทำงานได้ตามปกติ หากเกิดขึ้นบ่อยครั้งหรือเกิดขึ้นต่อเนื่อง แนะนำให้ปรึกษาทีมบริการ",
      wifireset4: "โมดูล Wi-Fi เริ่มการทำงานใหม่ตามเงื่อนไขที่กำหนดโดยระบบ",
      wifireset4detail:
        "เหตุการณ์นี้อาจเกิดขึ้นหลังการอัปเดตเฟิร์มแวร์ การเปลี่ยนแปลงการตั้งค่า หรือการรีสตาร์ตตามรอบเวลาที่กำหนด",
      wifireset5: "โมดูล Wi-Fi กลับมาทำงานหลังออกจากโหมดประหยัดพลังงาน",
      wifireset5detail:
        "เหตุการณ์นี้เป็นส่วนหนึ่งของการทำงานปกติของโหมดประหยัดพลังงาน และไม่ได้บ่งชี้ว่าอุปกรณ์เกิดความผิดปกติ",
      wifireset6: "โมดูล Wi-Fi เริ่มการทำงานใหม่จากสัญญาณรีเซ็ตที่ตรวจพบจากภายนอกวงจร",
      wifireset6detail:
        "เหตุการณ์นี้อาจเกิดจากสัญญาณรบกวนทางไฟฟ้า (Electrical Noise) หรือสัญญาณรบกวนที่ส่งผลต่อฮาร์ดแวร์ หากเกิดขึ้นบ่อยครั้ง แนะนำให้ตรวจสอบระบบไฟฟ้า การต่อสายดิน และสภาพแวดล้อมในการติดตั้ง",
      roomtempsum: "สรุปอุณหภูมิภายใน",
      evaptempsum: "สรุปอุณหภูมิคอยล์เย็น",
      lowest: "ต่ำสุด",
      highest: "สูงสุด",
      average: "เฉลี่ย",
      hightempalarm: "แจ้งเตือนค่าอุณหภูมิด้านสูง",
      roomtemp: "อุณหภูมิภายใน",
      realtemp: "อุณหภูมิภายใน (เรียลไทม์)",
      realtemp2: "อุณหภูมิคอยล์เย็น (เรียลไทม์)",
      settemp: "อุณหภูมิที่ตั้งไว้",
      lowtempalarm: "แจ้งเตือนค่าอุณหภูมิด้านต่ำ",
      evaptemp: "อุณหภูมิคอยล์เย็น",
      datatable: "ตารางแสดงข้อมูล",
      time: "เวลา",
      tempunit: "หน่วยอุณหภูมิ",
      cel: "องศาเซลเซียส",
      fah: "องศาฟาเรนไฮต์",
      temptype: "รูปแบบเซ็นเซอร์วัดอุณหภูมิ",
      tempvalue: "ค่าอุณหภูมิ",
      min: "ต่ำสุด",
      max: "สูงสุุด",
      avg: "เฉลี่ย",
      search: "ค้นหากิจกรรม",
      activity: "กิจกรรม",
      type: "ประเภท",
      by: "โดย",
      timerSystem: "ระบบตั้งเวลาปิดเสียงแจ้งเตือนอัตโนมัติ",
      reporttitle: "รายงานการควบคุมอุณหภูมิ",
      reportsummary: "ข้อมูลสรุปอุณหภูมิ",
      opesummary: "ข้อมูลสรุปการทำงาน",
      opechart: "กราฟการทำงาน",
      opetable: "ตารางการทำงาน",
      opecooling: "ระบบทำความเย็น",
      opecontrol: "การควบคุม",
      statelegend: "แถบทึบ = ทำงาน/เปิด · ว่าง = หยุด/ปิด · ช่วงว่าง = ไม่มีข้อมูล",
      reasonpoweroffcooling: "ปุ่มพาวเวอร์ปิด → ระบบทำความเย็นหยุดทำงาน",
      reasonpoweroffstate: "ปุ่มพาวเวอร์: ปิด",
      reasoncompon: "คอมเพรสเซอร์ทำงาน (กำลังดึงอุณหภูมิลงจนถึงจุดตัด)",
      reasoncompoffdefrost: "คอมเพรสเซอร์หยุด — เพราะกำลังละลายน้ำแข็ง",
      reasoncompoffcycle: "คอมเพรสเซอร์หยุด — ถึงจุด setpoint แล้ว (รอจนอุณหภูมิสูงเกินค่าส่วนต่าง rd จึงกลับมาทำงาน) หรืออยู่ในช่วงหน่วงการทำงานของคอม",
      reasondefroston: "กำลังละลายน้ำแข็ง",
      reasonfanon: "พัดลมทำงาน",
      reasonfanoffdefrost: "พัดลมหยุด — ระหว่างละลายน้ำแข็ง",
      reasonfanoffdoor: "พัดลมหยุด — เพราะประตูเปิด",
      reasonfanoffconfig: "พัดลมหยุด — ขึ้นกับการตั้งค่าโหมดพัดลม (อุณหภูมิคอยล์ / ตามคอม / หน่วงหลังละลายน้ำแข็ง)",
      reasondooropen: "ประตู: เปิดอยู่",
      reasonpoweron: "ปุ่มพาวเวอร์: เปิด (ควบคุมทุกส่วน)",
      reasonlighton: "ไฟแสงสว่าง: เปิด",
      reasonlightoff: "ไฟแสงสว่าง: ปิด",
      reasondoorclosed: "ประตู: ปิด",
      reasonnodata: "ไม่มีข้อมูลช่วงนี้",
      powersummary: "ข้อมูลสรุปพาวเวอร์มิเตอร์",
      powerchart: "กราฟพาวเวอร์มิเตอร์",
      powertable: "ตารางพาวเวอร์มิเตอร์",
      iotsummary: "ข้อมูลสรุป IOT",
      iotchart: "กราฟระดับสัญญาณ",
      iottable: "ตาราง IOT",
      rssiname: "ระดับสัญญาณ",
      wifidrop: "Wi-Fi หลุด",
      xlsoperecords: "บันทึกสถานะ",
      xlsopeevents: "เหตุการณ์",
      changes: "การเปลี่ยนแปลง",
      totalreadings: "ข้อมูลทั้งหมด",
      duration: "ระยะเวลาจัดเก็บ",
      dataperiod: "ระยะเวลาบันทึกข้อมูล",
      rowunit: "รายการ",
      fromrecorded: "จาก",
      datacount: "จำนวนข้อมูล",
      perpage: "รายการ / หน้า",
      showing: "แสดง",
      oftotal: "จากทั้งหมด",
      xlsinfo: "สรุปข้อมูล",
      xlshistory: "ประวัติอุณหภูมิ",
      xlsbreaches: "ช่วงที่หลุดขอบเขต",
      xlsfield: "รายการ",
      xlsvalue: "ข้อมูล",
      xlsnobreach: "ไม่มีช่วงที่อุณหภูมิหลุดขอบเขตในช่วงเวลานี้",
      thresholdrange: "ขอบเขตอุณหภูมิที่กำหนด",
      outofrange: "หลุดขอบเขต",
      briefexcursion: "หลุดชั่วขณะ",
      loadingdata: "กำลังโหลดข้อมูล...",
      reportdownloadbtn: "ดูรายงานเต็ม · ดาวน์โหลด PDF/Excel",
      reportexcelbtn: "ดูรายงานเต็ม · ดาวน์โหลด Excel",
      xlsstatus: "สถานะ",
      excelwysiwyg:
        "ไฟล์จะตรงกับตารางที่แสดงอยู่ — ปรับความละเอียดของข้อมูลได้ที่ตัวกรอง",
      tipalarm: "อุณหภูมิหลุดขอบเขตจนอุปกรณ์แจ้งเตือน",
      tipbrief:
        "กลับเข้าช่วงภายในเวลาหน่วงแจ้งเตือน อุปกรณ์จึงไม่แจ้งเตือน",
      nodatarange: "ไม่พบข้อมูลในช่วงเวลานี้",
      brieftag: "ชั่วขณะ",
      alertdelay: "เวลาหน่วงแจ้งเตือน",
      secunit: "วินาที",
      printedat: "วันที่ออกเอกสาร",
      docref: "เลขที่เอกสาร",
      issuedby: "จัดทำโดย",
      reporttype: "ประเภทรายงาน",
      pagelabel: "หน้า",
      periodhours: "รายชั่วโมง",
      perioddays: "รายวัน",
      periodweeks: "รายสัปดาห์",
      periodmonths: "รายเดือน",
      durationcol: "ระยะเวลา",
      firstreading: "ค่าเริ่มช่วง",
      lastreading: "ค่าล่าสุด",
      hishort: "ด้านสูง",
      loshort: "ด้านต่ำ",
      exportpdf: "ดาวน์โหลด PDF",
      downloadexcel: "ดาวน์โหลด Excel",
      reportchart: "กราฟอุณหภูมิ",
      temptable: "ตารางอุณหภูมิ",
      breachperiods: "ตารางแสดงรายการช่วงที่อุณหภูมิหลุดขอบเขต",
      readinglist: "ตารางแสดงรายการอ่านค่าอุณหภูมิ",
      colstart: "เริ่ม",
      colend: "สิ้นสุด",
      coltype: "ประเภท",
      colpeak: "ค่าอุณหภูมิหลุดขอบเขต",
      collimit: "ขอบเขตขณะนั้น",
      colcount: "จำนวนค่า",
      overhigh: "สูงเกิน",
      underlow: "ต่ำเกิน",
      sensorcol: "เซ็นเซอร์ 1",
      devicecol: "อุปกรณ์",
      showevery: "แสดงทุก",
      minunit: "นาที",
      page: "หน้า",
      inspector: "เจ้าหน้าที่ผู้ตรวจสอบ",
      authorizer: "ผู้มีอำนาจลงนาม",
      recipient: "หน่วยงานผู้รับบริการ",
      signhere: "ลายมือชื่อ / Signature",
      signdate: "วันที่ / Date",
      reportsettings: "ตั้งค่ารายงาน PDF",
      resolution: "ความละเอียดตารางอุณหภูมิ",
      dataresolution: "ความละเอียดของข้อมูล",
      recommended: "แนะนำ",
      resnotrecommend:
        "ละเอียดกว่าที่แนะนำสำหรับช่วงเวลานี้ อาจทำให้กราฟทำงานหนักและข้อมูลดูยากขึ้น แต่ยังใช้งานได้",
      resbreachnote:
        "ค่าที่อยู่นอกช่วงกำหนด (Out of range) จะแสดงแยกเป็นรายการของตัวเองเสมอ ไม่ถูกนำไปรวมในค่าเฉลี่ย แม้ปรับความละเอียดเป็นช่วงเวลาที่กว้างขึ้น เพื่อให้เห็นครบทุกจุดที่หลุดขอบเขต",
      tblsettemp: "ค่าที่ตั้งไว้",
      tbllowalarm: "ขอบเขตด้านต่ำ",
      tblhighalarm: "ขอบเขตด้านสูง",
      tblinside: "ภายใน",
      tblinsidert: "ภายใน (เรียลไทม์)",
      tblcoil: "คอยล์เย็น",
      tblcoilrt: "คอยล์เย็น (เรียลไทม์)",
      includechart: "แสดงกราฟในรายงาน",
      chartseries: "เส้นกราฟที่แสดงในรายงาน",
      confirmdownload: "ยืนยัน — ดาวน์โหลด PDF",
      recordtype: "รูปแบบการบันทึกข้อมูล",
      record: "ระยะเวลาบันทึก",
      event: "เหตุการณ์",
      register: "สมัครใช้งาน",
      starterblocked:
        "อุปกรณ์แพ\u2060ลน Starter ไม่รองรับการใช้งานบนระบบ Monitoring",
      starterblockeddetail:
        "สามารถใช้งานอุปกรณ์นี้ได้ตามปกติผ่านแอปพลิเคชัน CORNTROL หรือสมัครแพ\u2060ลน Standard / Professional เพื่อใช้งานบนระบบ Monitoring",
      backtodevices: "กลับไปหน้ารายการอุปกรณ์",
      comp: "คอมเพรสเซอร์",
      defrost: "ละลายน้ำแข็ง",
      fan: "พัดลม",
      door: "ประตู",
      times: "ครั้ง",
      hrs: "ชั่วโมง",
      active: "ปุ่มพาวเวอร์",
      light: "ไฟแสงสว่าง",
      on1: "เปิด",
      off1: "ปิด",
      on2: "ทำงาน",
      off2: "หยุดทำงาน",
      actionpower: "เปิด / ปิดการทำงานของอุปกรณ์",
      actionlight: "เปิด / ปิดไฟส่องสว่าง",
      appact: "เปิดใช้งานโดยแอปพลิเคชั่น",
      appdea: "ปิดใช้งานโดยแอปพลิเคชั่น",
      manact: "เปิดใช้งานด้วยตนเอง",
      mandea: "ปิดใช้งานด้วยตนเอง",
      electunit: "หน่วยไฟฟ้า",
      electbill: "ค่าไฟฟ้า",
      carbonfootprint: "คาร์บอนฟุตพรินต์",
      carbonunit: "kgCO₂e",
      mode: "โหมด",
      unit2: "หน่วย",
      baht: "บาท",
      vol: "แรงดันไฟฟ้า (Vac)",
      volname: "แรงดันไฟฟ้า",
      amp: "กระแสไฟฟ้า (Amp)",
      watt: "กำลังไฟฟ้า (Watt)",
      wattname: "กำลังไฟฟ้า",
      khw: "กิโลวัตต์/ชั่วโมง",
      wifi: "Wi-Fi",
      devicestatus: "สถานะอุปกรณ์",
      rssi: "ระดับสัญญาณ (dBm)",
      iothead: "อุปกรณ์ IoT — ชื่อเครือข่าย (SSID)",
      connect: "เชื่อมต่อ",
      unable: "ไม่เชื่อมต่อ",
      online: "ออนไลน์",
      offline: "ออฟไลน์",
      iotdetail: "ข้อมูล IOT",
      opedetail: "ข้อมูลการทำงาน",
      tempdetail: "ข้อมูลอุณหภูมิ",
      etc: "หมายเหตุ: หากใช้งานกับอุปกรณ์ใหม่ กรุณาเปิดใช้งานแผนพื้นฐานก่อนเพื่อใช้ฟีเจอร์ดังกล่าว",
      buy: "คุณยังไม่มีการสมัครใช้งานแผนพื้นฐาน หรือแผนมืออาชีพในขณะนี้ กรุณาอัปเกรดเพื่อเข้าถึงฟีเจอร์ขั้นสูง หากต้องการความช่วยเหลือเพิ่มเติม กรุณาติดต่อฝ่ายสนับสนุนได้ที่ Line Official: @corntrol หรืออีเมล info@corntrol.com",
    },
    filter:{
      hours: "วันที่",
      days: "วันที่",
      weeks: "สัปดาห์ที่",
      months: "เดือนที่",
      years: "ปีที่"
    }
  },
};

export const useMyTranslation = () => {
  const dispatch = useDispatch();
  const language = useSelector(
    (state: stateInterface) => state.storage.language
  );

  const t = (key: any) => {
    const translations: any = resources[language] || resources["en"];
    // ฟังก์ชันช่วยเพื่อเจาะลึก nested objects ตาม dot notation
    const getNestedValue = (obj: any, path: any) => {
      return path.split(".").reduce((acc: any, part: any) => {
        return acc ? acc[part] : undefined;
      }, obj);
    };
    const result = getNestedValue(translations, key);
    return result || "-"; // กลับคืน key ถ้าไม่เจอค่า
  };

  const changeLanguage = (lng: any) => {
    dispatch(switchLanguageAction(lng));
  };

  return { t, changeLanguage, currentLanguage: language };
};
